  /**
   * @param {string} element
   * @returns {boolean}
   */
  function isStringNullish(element) {
    return element === null || element === undefined || element === "";
  }
  

  if (!customElements.get("product-pack")) {
    class ProductPack extends HTMLElement {
      constructor() {
        super();
        this.packs = this.querySelectorAll(".pack-wrapper .pack");
      }
  
      connectedCallback() {
        this.listenEvents();
      }
  
      listenEvents() {
        this.onPackSelection();
      }

      resetSelectedPack() {
        document.querySelectorAll(".pack-wrapper .pack").forEach((pack) => {
          pack.classList.remove("pack-selected");
        });
      }
  
      onPackSelection() {
        const globalThis = this;
        this.packs.forEach((pack) => {
          pack.addEventListener("click", function () {
            if(pack.dataset.available === 'false') {
              return;
            }

            globalThis.resetSelectedPack();
            pack.classList.add("pack-selected");
            document.querySelector('product-info .quantity__input').value = pack.dataset.quantity;
              
          });
        });
      }

      updateQuantity() {
        const selectedPack = document.querySelector(".pack-wrapper .pack-selected");
        if (selectedPack && !isStringNullish(selectedPack.dataset.quantity)) {
          document.querySelector('product-info .quantity__input').value = selectedPack.dataset.quantity;
        }
      }
  
    }
    customElements.define("product-pack", ProductPack);
  }
  